/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Notifications_Simple_Subscribedto1Inputs */

const id_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berlangganan ke ${i?.name}`)
};

const ms_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dilanggan kepada ${i?.name}`)
};

const da_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonneret på ${i?.name}`)
};

const de_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} abonniert`)
};

const en_us2_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscribed to ${i?.name}`)
};

const es_es2_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscrito a ${i?.name}`)
};

const es_mx2_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscrito a ${i?.name}`)
};

const fil_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Naka-subscribe sa ${i?.name}`)
};

const fr_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonné à ${i?.name}`)
};

const it_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iscritto a ${i?.name}`)
};

const hu_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feliratkozva: ${i?.name}`)
};

const nl_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geabonneerd op ${i?.name}`)
};

const no_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnert på ${i?.name}`)
};

const pl_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subskrybowano ${i?.name}`)
};

const pt_br2_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscribed to ${i?.name}`)
};

const pt_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscrito a ${i?.name}`)
};

const ro_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonat la ${i?.name}`)
};

const fi_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilattu ${i?.name}`)
};

const sv_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prenumererar på ${i?.name}`)
};

const vi_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã đăng ký ${i?.name}`)
};

const tr_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aboneliği yapıldı`)
};

const cs_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Přihlášeno k ${i?.name}`)
};

const bg_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Абониран за ${i?.name}`)
};

const ru_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подписан на ${i?.name}`)
};

const uk_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Підписано на ${i?.name}`)
};

const ar_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مشترك في ${i?.name}`)
};

const hi_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} की सदस्यता ली`)
};

const th_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สมัครรับ ${i?.name} แล้ว`)
};

const ja_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を購読しました`)
};

const zh_cn2_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscribed to ${i?.name}`)
};

const zh_hant1_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscribed to ${i?.name}`)
};

const ko_notifications_simple_subscribedto1 = /** @type {(inputs: Notifications_Simple_Subscribedto1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscribed to ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Subscribed to {name}" |
*
* @param {Notifications_Simple_Subscribedto1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_subscribedto1 = /** @type {((inputs: Notifications_Simple_Subscribedto1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Subscribedto1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_subscribedto1(inputs)
	if (locale === "ms") return ms_notifications_simple_subscribedto1(inputs)
	if (locale === "da") return da_notifications_simple_subscribedto1(inputs)
	if (locale === "de") return de_notifications_simple_subscribedto1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_subscribedto1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_subscribedto1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_subscribedto1(inputs)
	if (locale === "fil") return fil_notifications_simple_subscribedto1(inputs)
	if (locale === "fr") return fr_notifications_simple_subscribedto1(inputs)
	if (locale === "it") return it_notifications_simple_subscribedto1(inputs)
	if (locale === "hu") return hu_notifications_simple_subscribedto1(inputs)
	if (locale === "nl") return nl_notifications_simple_subscribedto1(inputs)
	if (locale === "no") return no_notifications_simple_subscribedto1(inputs)
	if (locale === "pl") return pl_notifications_simple_subscribedto1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_subscribedto1(inputs)
	if (locale === "pt") return pt_notifications_simple_subscribedto1(inputs)
	if (locale === "ro") return ro_notifications_simple_subscribedto1(inputs)
	if (locale === "fi") return fi_notifications_simple_subscribedto1(inputs)
	if (locale === "sv") return sv_notifications_simple_subscribedto1(inputs)
	if (locale === "vi") return vi_notifications_simple_subscribedto1(inputs)
	if (locale === "tr") return tr_notifications_simple_subscribedto1(inputs)
	if (locale === "cs") return cs_notifications_simple_subscribedto1(inputs)
	if (locale === "bg") return bg_notifications_simple_subscribedto1(inputs)
	if (locale === "ru") return ru_notifications_simple_subscribedto1(inputs)
	if (locale === "uk") return uk_notifications_simple_subscribedto1(inputs)
	if (locale === "ar") return ar_notifications_simple_subscribedto1(inputs)
	if (locale === "hi") return hi_notifications_simple_subscribedto1(inputs)
	if (locale === "th") return th_notifications_simple_subscribedto1(inputs)
	if (locale === "ja") return ja_notifications_simple_subscribedto1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_subscribedto1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_subscribedto1(inputs)
	return ko_notifications_simple_subscribedto1(inputs)
});
export { notifications_simple_subscribedto1 as "notifications.simple.subscribedTo" }